export const TOOL_NAMES = {
	ISSUE_SEARCH: 'IssueSearchTool',
} as const;
